<template>
    <div class="row col-12 pr-0 d-print-none">
        <div class="col-lg-12 pr-0">
            <hr class="colorgraph">
            <div class="px-3 py-2 user-information-section">
                <div class="head-title mb-2">
                    <strong v-if="app_mode==='ORACLE'">{{ $lang('Zgłoszenie zostało rozwiązane') }}</strong>
                    <strong v-else-if="app_mode==='QUATRA'">{{ $lang('Rozwiązanie') }}</strong>
                </div>
                <div v-if="app_mode==='QUATRA'">
                    <div><strong>{{ $lang('Opis rozwiązania:') }}</strong></div>
                    <div>{{ task.resolution_description }}</div>
                    <template v-if="task.fix_version">
                        <div class="mt-2"><strong>{{ $lang('Numer aktualizacji') }}</strong></div>
                        <div>{{ task.fix_version }}</div>
                    </template>
                </div>
                <div class="text-right mt-2">
                                <span class="mr-2 align-bottom">
                                    <strong>{{ $lang('Czy potwierdzasz poprawność rozwiązania?') }}</strong>
                                </span>
                    <form class="d-inline-block mr-2" method="post" :action="confirm_route" ref="confirmForm">
                        <input type="hidden" name="_token" v-bind:value="csrf">
                        <button v-if="editDataBeforeConfirm" type="button" class="btn btn-primary"
                                @click="confirmAttempt">{{ $lang('Tak') }}
                        </button>
                        <button v-else type="button" class="btn btn-primary" @click.once="confirm">{{ $lang('Tak') }}
                        </button>
                    </form>
                    <div class="d-inline-block">
                        <button type="button" class="btn btn-default" data-toggle="modal"
                                data-target="#rejectionReasonModal">{{ $lang('Nie') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="rejectionReasonModal" tabindex="-1" role="dialog"
             aria-labelledby="rejectionReasonModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <form method="post" :action="reject_route" ref="rejectForm">
                        <input type="hidden" name="_token" v-bind:value="csrf">
                        <div class="modal-header">
                            <h5 class="modal-title"
                                id="rejectionReasonModalTitle">{{ $lang('Powód odrzucenia rozwiązania') }}</h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    :aria-label="$lang('Zamknij')">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="rejectionReason">
                                    {{ $lang('Rozwiązanie zostanie odrzucone. Proszę podać przyczynę.') }}
                                </label>
                                <textarea class="form-control mt-1" id="rejectionReason" rows="3"
                                          name="rejection_reason" v-model="rejectionReason"></textarea>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default"
                                    data-dismiss="modal">{{ $lang('Anuluj') }}
                            </button>
                            <button type="button" class="btn btn-primary" :disabled="!rejectionReasonGiven"
                                    @click.once="reject">
                                {{ $lang('Zatwierdź') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal fade" id="confirmationEditDataModal" tabindex="-1" role="dialog" v-if="editDataBeforeConfirm"
             aria-labelledby="confirmationEditDataModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <input type="hidden" name="_token" v-bind:value="csrf">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmationEditDataModalTitle">
                            {{ $lang('Zamknięcie zgłoszenia') }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal"
                                :aria-label="$lang('Zamknij')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form method="post" :action="confirm_route" ref="confirmDataForm">
                            <input type="hidden" name="_token" v-bind:value="csrf">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label for="tester_confirm">{{ $lang('Tester') }}</label>
                                    <div class="input-group mb-2">
                                        <input type="text" class="form-control" name="details[tester]"
                                               id="tester_confirm"
                                               autocomplete="chrome-off" v-model="editableData.tester">
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12 col-12 form-group">
                                    <label for="package_accepted_confirm">{{ $lang('Akceptacja wdrożenia') }}</label>
                                    <div class="input-group mb-2">
                                        <input type="text" class="form-control" name="details[package_accepted]"
                                               id="package_accepted_confirm"
                                               autocomplete="chrome-off" v-model="editableData.package_accepted">
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12 col-12 form-group">
                                    <datepicker-accessible
                                        :label-single="$lang('Data akceptacji')"
                                        custom-id="package_accepted_at_confirm"
                                        name="package_accepted_at"
                                        mode="date"
                                        :use_pencil_checkbox="false"
                                        :strong_label="false"
                                        v-model="editableData.package_accepted_at"
                                        :is_required="false"
                                    ></datepicker-accessible>
                                    <input hidden type="date" class="form-control" name="details[package_accepted_at]"
                                           id="package_accepted_at"
                                           autocomplete="chrome-off" v-model="editableData.package_accepted_at">
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            {{ $lang('Anuluj') }}
                        </button>
                        <button type="button" class="btn btn-primary" @click.once="confirmAndSave">
                            {{ $lang('Zapisz') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import DatepickerAccessible from "../datepicker-accessible.vue";

export default {
    name: "task-confirm-component",
    components: {DatepickerAccessible},
    props: {
        confirm_route: {type: String, required: true},
        reject_route: {type: String, required: true},
        csrf: {type: String, required: true},
        app_mode: {type: String, required: true},
        project: {type: String, required: false, default: ''},
        task: {type: Object, required: true},
    },
    data() {
        return {
            rejectionReason: '',
            editableData: {
                tester: '',
                package_accepted: '',
                package_accepted_at: ''
            }
        }
    },
    methods: {
        confirmAttempt() {
            this.assignData();
            $('#confirmationEditDataModal').modal('show');
        },
        confirm() {
            this.$refs.confirmForm.submit();
        },
        confirmAndSave() {
            this.$refs.confirmDataForm.submit();
        },
        reject() {
            this.$refs.rejectForm.submit();
        },
        assignData() {
            this.editableData.tester = structuredClone(this.task.details?.tester);
            this.editableData.package_accepted = structuredClone(this.task.details?.package_accepted);
            this.editableData.package_accepted_at = structuredClone(this.task.details?.package_accepted_at ?? '');
        }
    },
    computed: {
        rejectionReasonGiven() {
            return this.rejectionReason !== '' && this.rejectionReason !== null;
        },
        editDataBeforeConfirm() {
            return this.app_mode === 'ORACLE' && this.project === 'BPH';
        }
    }
}
</script>
